import { render, staticRenderFns } from "./LayoutEditConfigTab.vue?vue&type=template&id=24cfa9be"
import script from "./LayoutEditConfigTab.vue?vue&type=script&lang=ts"
export * from "./LayoutEditConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports